// extracted by mini-css-extract-plugin
export default {"buttonGroup":"EditUser_buttonGroup__0IyyY","editButton":"EditUser_editButton__YjdcC","cancelButton":"EditUser_cancelButton__om50T","fields":"EditUser_fields__uI0b4"};